import { z } from "zod";

import { CreateUserDtoSchema, UserDtoSchema } from "../../../dtos/users";

export const CreateUserRequestBodySchema = z.object({
  user: CreateUserDtoSchema,
});

export const CreateUserResponseBodySchema = z.object({
  user: UserDtoSchema,
});

export type CreateUserRequestBodyType = z.infer<
  typeof CreateUserRequestBodySchema
>;
export type CreateUserResponseBodyType = z.infer<
  typeof CreateUserResponseBodySchema
>;
